import { useEffect, useState } from 'react';

// useDebouncedValue — returns `value` delayed by `delay`ms (default 300).
// Use to debounce a fast-changing input (text search, slider) before
// gating an expensive effect (fetch, regex, etc).
//
// Example:
//   const [input, setInput] = useState('');
//   const search = useDebouncedValue(input, 300);
//   useEffect(() => { fetch(`/api?q=${search}`); }, [search]);

export function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}

export default useDebouncedValue;
